import { Organisation, PlanPackage } from '@common/types/objects';

const getCurrentPlanPackage = (organisation: Organisation): PlanPackage | undefined => {
  return organisation.plan_package_list?.find(
    ({ id }) => id === `${organisation.plan_package}`,
  );
};

export default getCurrentPlanPackage;
